export const enum AnalyticsEvent {
  Started = "2024-05-20T16-54-14z03-00-2gja5B",
  Paused = "2024-05-30T14-32-38z03-00-2hBY65",
  Resumed = "2024-05-30T14-33-01z03-00-2hBY8y",
  Downloaded = "2024-05-29T15-31-09z03-00-2h8q5c",
  Completed = "2024-05-27T13-49-53z03-00-2h2zWh",
  Passed = "2024-06-17T14-44-44z03-00-2i0Pn2",
  Rated = "2024-06-27T12-00-27z03-00-2iSL2u",
}

export enum AnalyticsParent {
  Scorm = "2023-09-11T06-56-29Z-589a8d",
  Pdf = "2023-09-06T06-30-03Z-cee90b",
  Audio = "2024-04-15T13-11-07z03-00-3c5b30",
  Longread = "2023-11-13T10-46-31Z-c30d09",
  PowerPoint = "2023-09-11T06-58-35Z-f4ecc2",
  Jpeg = "2023-09-11T06-54-01Z-e068b4",
  Video = "2023-09-06T07-39-32Z-b0d9dd",
  Test = "2023-09-06T07-39-14Z-949055",
  Folder = "31YUccyWDWaHsytSRDaSXHqbSJZ",
  // TODO not used now, but mb need in future
  Quotes = "2nYnWp5m1CXL9BBVICgXlJjLL3M",
  Event = "2023-09-11T06-57-39Z-1a3e4a",
  Docx = "2024-08-14T09-15-26z03-00-2kdau7",
  Excel = "2023-09-11T06-59-45Z-d467ac",
  Link = "2024-02-26T10-35-59Z-1f0930",
  Webinar = "2023-09-06T07-41-03Z-6468aa",
}

export type AnalyticsMutationArgs = {
  unitid: string,
  publicationid: string,
  material: string,
  type: AnalyticsEvent,
  parent: AnalyticsParent,
  time?: number,
  progressMeasure?: number,
  //material rating
  materialRate?: number,
  materialClarity?: number,
  materialInterest?: number,
  materialRelevance?: number,
  materialComment?: string,
};

export type TrackPayload = Omit<
  AnalyticsMutationArgs,
  "publicationid" | "unitid" | "material" | "parent"
>;
